import { ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$ } from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_serializersStore() {
  _init_properties_DefaultJs_kt__opfp8o();
  return serializersStore;
}
var serializersStore;
var properties_initialized_DefaultJs_kt_mit67a;
function _init_properties_DefaultJs_kt__opfp8o() {
  if (!properties_initialized_DefaultJs_kt_mit67a) {
    properties_initialized_DefaultJs_kt_mit67a = true;
    // Inline function 'kotlin.collections.mutableListOf' call
    serializersStore = ArrayList_init_$Create$();
  }
}
//region block: exports
export {
  get_serializersStore as get_serializersStore3e4gm3fdgip9r,
};
//endregion

